import { render, staticRenderFns } from "./BlueShadow2.vue?vue&type=template&id=6d48cce4&scoped=true&lang=pug"
import script from "./BlueShadow2.vue?vue&type=script&lang=js"
export * from "./BlueShadow2.vue?vue&type=script&lang=js"
import style0 from "./BlueShadow2.vue?vue&type=style&index=0&id=6d48cce4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48cce4",
  null
  
)

export default component.exports